<bb-frame-select [mediaclip]="mediaclip" [select]="'range'" (trimchange)="onTrimChanged($event)"></bb-frame-select>

<bb-message *ngIf="mediaclip?.subtitles?.length || mediaclip?.audiotracks?.length || mediaclip?.timelines?.length">
	{{ 'HELP.TRIM_MEDIA_WARNING' | translate }}
</bb-message>
<bb-message *ngIf="mediaclip?.YouTube_id">
	{{ 'EXPORTED_TO_YOUTUBE_REPLACE_WARNING_DESC' | translate }}
</bb-message>

<div class="action-buttons">
	<bb-button class="cancel" icon="ban" (click)="onCancelClick()">
		{{ 'CANCEL' | translate }}
	</bb-button>
	<bb-button [icon]="mediaclip?.mediatype === 'video' ? 'film' : 'volume-up'" (click)="onSaveClick(true)"
		[disabled]="!(isTrimmed)" [loading]="processing">
		{{ 'SAVE_AS_NEW_CLIP' | translate }}
	</bb-button>
	<bb-button [icon]="mediaclip?.mediatype === 'video' ? 'film' : 'volume-up'" (click)="onSaveClick(false)"
		[disabled]="!(isTrimmed)" [loading]="processing">
		{{ 'REPLACE' | translate }}
	</bb-button>
</div>
